// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.delete[data-v-c49e64f0],\n.info[data-v-c49e64f0] {\n  margin-top: 40px;\n}\n.info[data-v-c49e64f0] {\n  max-height: 24px;\n  max-width: 24px;\n  min-height: 24px;\n  min-width: 24px;\n  color: rgba(10, 10, 10, 0.2);\n}\ndiv.disabled duet-date-picker[data-v-c49e64f0] {\n  opacity: 0.5;\n}\n.tag:not(body) .delete[data-v-c49e64f0] {\n  margin-top: 0px;\n}\n.spacer[data-v-c49e64f0] {\n  width: 24px;\n}\nhr[data-v-c49e64f0] {\n  margin: 5px 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
